// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SmsActionResponse

import { BookingEventActionType } from './enums.gen';

export type SmsActionApiResponse = {
	type: BookingEventActionType.Sms;
	message: string;
};

export type SmsAction = {
	type: BookingEventActionType.Sms;
	message: string;
};

export function hydrateSmsAction(data: SmsActionApiResponse): SmsAction {
	return { ...data };
}